import { render, staticRenderFns } from "./FacebookLink.vue?vue&type=template&id=ba5fea4e&scoped=true"
var script = {}
import style0 from "./FacebookLink.vue?vue&type=style&index=0&id=ba5fea4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5fea4e",
  null
  
)

export default component.exports